import * as R from 'ramda';

import WorkOrderList from '@atom/components/mapPortal/drawerContent/WorkOrdersList';
import { SearchParamType, useNavigation } from '@atom/hooks/useNavigation';

import { useListView } from '../hooks/listViewHook';
import { initialState } from '../hooks/mapDataHook';

const WorkOrderGroupListWrapper = () => {
  const [listView = initialState] = useListView();
  const [{ id: idParam }, { updateSearchParams }] = useNavigation({
    id: SearchParamType.STRING,
    view: SearchParamType.STRING,
  });

  const workOrders = R.pipe(
    R.propOr([], 'workOrders'),
    // @ts-ignore
    R.filter(R.propSatisfies(R.includes(R.__, idParam), 'id')),
    // @ts-ignore
  )(listView);

  const onClick = id => {
    updateSearchParams({ id, view: 'workOrder' });
  };

  return (
    /* @ts-ignore */
    <WorkOrderList workOrders={workOrders} navigateToWorkOrder={onClick} />
  );
};

export default WorkOrderGroupListWrapper;
